function Footer() {
  return (
    <footer className="mt-auto py-4 bg-custom-light">
      <div className="px-3 d-flex justify-content-between">
        <span className="me-auto text-muted">&copy; Copyright 2021</span>
        <a href="!#" className="text-decoration-none">
          Back to top
        </a>
      </div>
    </footer>
  );
}

export default Footer;
